import { IconButton } from "@mui/material";
import { IconTrash } from "@tabler/icons";

const DisabledDeleteIcon = () => (

        <IconButton size="small" disabled>
          <IconTrash size="1.1rem" />
        </IconButton>
  );

  export default DisabledDeleteIcon;
  